import { IonButton, IonContent, IonIcon, IonInput, IonItem, IonList, IonListHeader, IonPage, withIonLifeCycle } from "@ionic/react";
import { key, person } from "ionicons/icons";
import React, { FormEvent } from "react";
import { ShowToast } from "../components/Alerts";
import { Authentication } from "../components/Authentication";
import logo from "../images/logo.svg";
import logo_acx from "../images/logo_acromax.svg";
import logo_ss from "../images/logo_salud.svg";

class LoginPage extends React.Component{

    submit = async (e:FormEvent) => {
        e.preventDefault()
        const {response,error} = await Authentication.login(this.state)
        if(response){
            window.location.replace("/home")
        }else{
            await ShowToast(error || "Error en el servicio","Error al iniciar sesión","danger")
        }
    }

    render(){
        return (
            <IonPage>
                <IonContent fullscreen className="no-bg fondo-colores">
                    <form className="fixed-center" onSubmit={this.submit}>
                        <IonList lines="none" className="no-bg" mode="md">
                            <IonItem lines="none" className="no-bg">
                                <div style={{textAlign:"center",display:"block",width:"100%"}}>
                                    <img src={logo} alt="Acrofit" width={200} />
                                </div>
                            </IonItem>
                            <IonListHeader lines="none">
                                <h1 style={{textAlign:"center",width:"100%"}}>Ingresar</h1>
                            </IonListHeader>
                            <IonItem lines="none" style={{marginBottom:5}}>
                                <IonIcon icon={person} slot="start" />
                                <IonInput type="email" placeholder="Correo electrónico" onIonChange={e => this.setState({correo:e.detail.value})} required />
                            </IonItem>
                            <IonItem lines="none" style={{marginBottom:5}}>
                                <IonIcon icon={key} slot="start" />
                                <IonInput type="password" placeholder="Contraseña" onIonChange={e => this.setState({password:e.detail.value})} required />
                            </IonItem>
                            <IonButton type="submit" expand="block">Ingresar</IonButton>
                            <IonItem lines="none" className="no-bg" >
                                Si no estás registrado, registrate aquí:
                            </IonItem>
                            <IonButton color="warning" routerLink="/registro" expand="block">Registrarme</IonButton>
                            <IonItem lines="none" className="no-bg">
                                <div style={{textAlign:"center",display:"block",width:"100%"}}>
                                    <img src={logo_acx} alt="Acrofit" width={80} />
                                </div>
                            </IonItem>
                            <IonItem lines="none" className="no-bg">
                                <div style={{textAlign:"center",display:"block",width:"100%"}}>
                                    <img src={logo_ss} alt="Acrofit" width={200} />
                                </div>
                            </IonItem>
                        </IonList>
                    </form>
                </IonContent>
            </IonPage>
        )
    }
}

export default withIonLifeCycle(LoginPage);